module.exports = __webpack_public_path__ + "img/1b69be1.png";